import { useAppDispatch } from './state'
import { getAgency as getAgencyAPI } from '../api/agency'
import { setAgency } from '../state/slices/agency_slice'

export const useAgency = () => {
  const dispatch = useAppDispatch()

  const getAgency = async (id: string): Promise<boolean> => {
    try {
      const result = await getAgencyAPI(id)

      if (result.data) {
        dispatch(setAgency(result.data))
      }

      return true
    } catch (error) {
      return false
    }
  }

  return {
    getAgency
  }
}

export default useAgency
